import { render, staticRenderFns } from "./CityItem.vue?vue&type=template&id=027de940&scoped=true&"
import script from "./CityItem.vue?vue&type=script&lang=js&"
export * from "./CityItem.vue?vue&type=script&lang=js&"
import style0 from "./CityItem.vue?vue&type=style&index=0&id=027de940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027de940",
  null
  
)

export default component.exports